<template>
  <div class="row">
    <div class="d-flex justify-content-between ml-3 mr-2" style="width: 100%">
      <div>
        <cabecalho title="FICHA_SAUDE.FICHA_SAUDE" title_type="body" />
      </div>
    </div>
    <div class="col-12">
      <div class="mt-4">
        <h4>
          {{ $t('FICHA_SAUDE.OBSERVACOES') }}
        </h4>
        <b-row>
          <input-text
            class="col-6"
            ref="fichaSaude.planoDeSaude"
            v-model="fichaSaude.planoDeSaude"
            :label="$t('FICHA_SAUDE.PLANO_SAUDE')"
            :placeholder="$t('FICHA_SAUDE.PLANO_SAUDE_PLACEHOLDER')"
            disabled
          />
          <input-text
            class="col-6"
            ref="fichaSaude.numeroCarteirinha"
            v-model="fichaSaude.numeroCarteirinha"
            :label="$t('FICHA_SAUDE.PLANO_SAUDE_NUMERO_CARTEIRINHA')"
            :placeholder="
              $t('FICHA_SAUDE.PLANO_SAUDE_NUMERO_CARTEIRINHA_PLACEHOLDER')
            "
            disabled
          />
        </b-row>
      </div>
      <div class="mt-4">
        <h4>
          {{ $t('FICHA_SAUDE.INTOLERANCIAS') }}
        </h4>
        <b-row>
          <b-col class="col-3">
            <input-checkbox
              ref="fichaSaude.intoleranciaLactose"
              v-model="fichaSaude.intoleranciaLactose"
              :label="$t('FICHA_SAUDE.INTOLERANCIAS_LACTOSE')"
              disabled
            />
          </b-col>
          <b-col class="col-3">
            <input-checkbox
              ref="fichaSaude.intoleranciaGluten"
              v-model="fichaSaude.intoleranciaGluten"
              :label="$t('FICHA_SAUDE.INTOLERANCIAS_GLUTEN')"
              disabled
            />
          </b-col>
          <b-col class="col-3">
            <input-checkbox
              ref="fichaSaude.refluxo"
              v-model="fichaSaude.refluxo"
              :label="$t('FICHA_SAUDE.REFLUXO')"
              disabled
            />
          </b-col>
        </b-row>
      </div>
      <div class="mt-4">
        <h4>
          {{ $t('FICHA_SAUDE.MEDICACOES') }}
        </h4>
        <b-row>
          <b-col class="col-12">
            <input-checkbox
              ref="fichaSaude.medicamentoContinuo"
              v-model="fichaSaude.medicamentoContinuo"
              class="mt-1"
              :label="$t('FICHA_SAUDE.MEDICACOES_CONFIRMACAO')"
              disabled
            />
          </b-col>
          <b-col>
            <input-text
              ref="fichaSaude.nomeMedicamento"
              v-model="fichaSaude.nomeMedicamento"
              :label="$t('FICHA_SAUDE.MEDICACOES_QUAIS')"
              :required="fichaSaude.medicamentoContinuo"
              disabled
            />
          </b-col>
          <b-col>
            <input-text
              ref="fichaSaude.motivoMedicamento"
              v-model="fichaSaude.motivoMedicamento"
              :label="$t('FICHA_SAUDE.MEDICACOES_MOTIVO')"
              :required="fichaSaude.medicamentoContinuo"
              disabled
            />
          </b-col>
        </b-row>
      </div>
      <div class="mt-4">
        <h4>
          {{ $t('FICHA_SAUDE.ALERGIAS') }}
        </h4>
        <b-row>
          <b-col class="col-12">
            <input-checkbox
              ref="fichaSaude.alergia"
              v-model="fichaSaude.alergia"
              :label="$t('FICHA_SAUDE.ALERGIA_CONFIRMACAO')"
              disabled
            />
          </b-col>
          <b-col>
            <input-text
              ref="fichaSaude.especificaoAlergia"
              :required="fichaSaude.alergia"
              v-model="fichaSaude.especificaoAlergia"
              :label="$t('FICHA_SAUDE.ALERGIA_QUAIS')"
              disabled
            />
          </b-col>
        </b-row>
      </div>
      <div class="mt-4">
        <h4>
          {{ $t('FICHA_SAUDE.DEFICIENCIAS') }}
        </h4>
        <b-row>
          <b-col>
            <input-checkbox
              ref="fichaSaude.deficiencia"
              v-model="fichaSaude.deficiencia"
              class="mt-1"
              :label="$t('FICHA_SAUDE.DEFICIENCIAS_CONFIRMACAO')"
              disabled
            />
            <input-text
              ref="fichaSaude.especificacaoDeficiencia"
              :required="fichaSaude.deficiencia"
              v-model="fichaSaude.especificacaoDeficiencia"
              :label="$t('FICHA_SAUDE.DEFICIENCIAS_ESPECIFIQUE')"
              :placeholder="$t('FICHA_SAUDE.DEFICIENCIAS_DESCRICAO_CID')"
              disabled
            />
          </b-col>
          <b-col>
            <p>{{ $t('FICHA_SAUDE.DEFICIENCIAS_SELECIONE') }}</p>
            <b-row>
              <b-col>
                <input-checkbox
                  ref="deficienciaFisica"
                  v-model="fichaSaude.deficienciaFisica"
                  :label="$t('FICHA_SAUDE.DEFICIENCIA_FISICA')"
                  disabled
                />
                <input-checkbox
                  ref="deficienciaVisual"
                  v-model="fichaSaude.deficienciaVisual"
                  :label="$t('FICHA_SAUDE.DEFICIENCIA_VISUAL')"
                  disabled
                />
                <input-checkbox
                  ref="deficienciaAuditiva"
                  v-model="fichaSaude.deficienciaAuditiva"
                  :label="$t('FICHA_SAUDE.DEFICIENCIA_AUDITIVA')"
                  disabled
                />
              </b-col>
              <b-col>
                <input-checkbox
                  ref="deficienciaIntelectual"
                  v-model="fichaSaude.deficienciaIntelectual"
                  :label="$t('FICHA_SAUDE.DEFICIENCIA_INTELECTUAL')"
                  disabled
                />
                <input-checkbox
                  ref="deficienciaPsicossocial"
                  v-model="fichaSaude.deficienciaPsicossocial"
                  :label="$t('FICHA_SAUDE.DEFICIENCIA_PSICOSSOCIAL')"
                  disabled
                />
                <input-checkbox
                  ref="deficienciaMultipla"
                  v-model="fichaSaude.deficienciaMultipla"
                  :label="$t('FICHA_SAUDE.DEFICIENCIA_MULTIPLA')"
                  disabled
                />
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </div>
      <div class="mt-4">
        <h4>
          {{ $t('FICHA_SAUDE.OBSERVACOES') }}
        </h4>
        <b-row class="mt-4">
          <b-col>
            <InputTextArea
              ref="fichaSaude.observacoes"
              v-model="fichaSaude.observacoes"
              :label="$t('FICHA_SAUDE.OBSERVACOES_OUTRAS')"
              disabled
            />
          </b-col>
        </b-row>
      </div>
    </div>
  </div>
</template>
<script>
// Utils & Aux:
import { START_LOADING, STOP_LOADING } from '@/store/Store';
import mensagem from '@/common/utils/mensagem';

import FichaSaudeService from '@/common/services/ficha-saude/ficha-saude.service';

import InputCheckbox from '@/components/inputs/InputCheckbox.vue';
import InputText from '@/components/inputs/InputText.vue';
import InputTextArea from '@/components/inputs/InputTextArea.vue';
import { Cabecalho } from '@/components/headers/index';

export default {
  components: {
    InputCheckbox,
    InputText,
    InputTextArea,
    Cabecalho,
  },
  props: {
    matriculaId: { type: String, default: null },
  },
  mounted() {
    this.listar();
  },
  data() {
    return {
      campos: [
        {
          key: 'codigo',
          label: 'Código pessoa',
          sortable: true,
        },
        {
          key: 'nome',
          label: 'Nome',
          sortable: true,
        },
        {
          key: 'tipoFiliacaoDescricao',
          label: 'Filiação',
          sortable: true,
        },
        {
          key: 'tipoResponsavelDescricao',
          label: 'Responsável por',
          sortable: true,
        },
        {
          key: 'contatos',
          label: 'Contatos',
        },
        {
          key: 'acoes',
          label: 'Mais ações',
        },
      ],
      fichaSaude: {},
    };
  },

  methods: {
    listar() {
      this.$store.dispatch(START_LOADING);
      FichaSaudeService.buscarPorMatriculaId(this.matriculaId)
        .then(({ data }) => {
          this.fichaSaude = data ? data : {};
        })
        .catch((err) => {
          mensagem.showErrors(err);
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },
  },
};
</script>
